type Props = {
  activeStep: number;
  totalSteps: number;
};

const Steps = ({ totalSteps, activeStep }: Props) => (
  <ul className="registration-steps">
    {[...Array(totalSteps + 1).keys()].slice(1).map(stepNum => {
      let stepClass = "";
      if (activeStep === stepNum) {
        stepClass = "step-active";
      } else if (activeStep > stepNum) {
        stepClass = "step-complete";
      }
      return (
        <li key={stepNum} className={stepClass}>
          <span>{stepNum}</span>
        </li>
      );
    })}
  </ul>
);

export default Steps;
